export function useFullScreenLoader() {
  const showFullScreenLoader = (customMessage) => {
    const loaderElement = document.createElement('div');
    loaderElement.id = 'full-screen-loader';
    loaderElement.style.cssText = `
      z-index: 100;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255,255,255,0.8);
      display: flex;
      align-items: center;
      justify-content: center;
    `;

    const loaderContent = document.createElement('div');
    loaderContent.className = 'text-center';
    loaderContent.style.cssText = 'max-width: 22.75rem;';

    const spinner = document.createElement('div');
    spinner.className = 'spinner-loader';

    const messageElement = document.createElement('h6');
    messageElement.className = 'margin-top-xxs';
    messageElement.textContent = customMessage;

    loaderContent.appendChild(spinner);
    loaderContent.appendChild(messageElement);
    loaderElement.appendChild(loaderContent);

    document.body.appendChild(loaderElement);
  };

  const hideFullScreenLoader = () => {
    const loaderElement = document.getElementById('full-screen-loader');
    if (loaderElement) loaderElement.remove();
  };

  return {
    showFullScreenLoader,
    hideFullScreenLoader,
  };
}
